export default __webpack_public_path__ + "static/media/Logo.e9c1eec9.png";